import { hapticFeedback } from '@tma.js/sdk-react';

// Вибрация по ТЗ (docs/spec/03): тап — light, гол и сейв — medium, идеальный удар — heavy, победа — success.
export type Haptic = 'tap' | 'goal' | 'save' | 'perfect' | 'win' | 'lose';

export function haptic(kind: Haptic): void {
  try {
    if (kind === 'win' || kind === 'lose') {
      if (hapticFeedback.notificationOccurred.isAvailable()) {
        hapticFeedback.notificationOccurred(kind === 'win' ? 'success' : 'error');
      }
      return;
    }
    if (!hapticFeedback.impactOccurred.isAvailable()) return;
    hapticFeedback.impactOccurred(kind === 'tap' ? 'light' : kind === 'perfect' ? 'heavy' : 'medium');
  } catch {
    // вне Telegram или старый клиент — без вибрации
  }
}
